import RemuneracaoMedicaChatApi from '@/Apis/RemuneracaoMedica/Services/RemuneracaoMedicaChatApi'
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { IRemuneracaoChatMessage, IRemuneracaoChatMessageType } from '@/types/interfaces/backoffice-remuneracao/remuneracao-chat-message.interface'
import EventBus from '@/plugins/EventBus'
import { chatRemuneracaoConnectionService } from '@/services/chat-remuneracao-connection.service'
import { Recebimento } from '@/types/_'
import { RemuneracaoMedica } from '@/types/core'
import { SolicitacaoChatAreaResponsavelEnum } from '../../../types/interfaces/solicitacao-chat/solicitacao-chat-area-responsavel.enum'

@Module({ namespaced: true, name: 'ChatFinanceiroStore' })
export default class ChatFinanceiroStore extends VuexModule {
  remuneracaoMedica: RemuneracaoMedica.IPrestadorRecebimento = new RemuneracaoMedica.PrestadorRecebimento()
  private open = false
  loading = false

  chatArea: SolicitacaoChatAreaResponsavelEnum | string = ''
  hospitalId = ''
  recebimento = {} as Recebimento
  userId = ''
  identificador = ''
  chatId = ''
  responsibleUserId?: string = ''
  responsibleUserName?: string = ''

  canEdit = true
  finished: boolean | null = false

  nomeGrupo = ''
  ehUsuarioAtendimento = false
  recipientLastSeenDate = ''
  recipientOnline = false

  messages: IRemuneracaoChatMessage[] = []
  connectionData = {} as IRemuneracaoChatMessage

  @Action
  async sendMessage(data: IRemuneracaoChatMessage) {
    console.log(data)
    if (this.isNew) {
      await this.context.dispatch('startChat')
    }

    const message: IRemuneracaoChatMessageType = {
      identificador: data.identificador,
      mensagem: data.mensagem,
      ehUsuarioAtendimento: data.ehUsuarioAtendimento,
    }

    const messageIndex = this.messages.length

    // Add the message before create in api
    const localMessage: IRemuneracaoChatMessage = {
      mensagem: message.mensagem,
      identificador: message.identificador,
      ehUsuarioAtendimento: message.ehUsuarioAtendimento,
      userId: data.userId,
      nomeGrupo: data.nomeGrupo,
      hospitalId: data.hospitalId,
      createdAt: new Date(),
    }

    if (localMessage.identificador !== this.identificador) {
      this.context.commit('addMessage', localMessage)
    }

    const res = await RemuneracaoMedicaChatApi.enviarMensagem(localMessage)
    if (!res.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao enviar mensagem', icon: 'warning', color: '#C62828' })
      // eslint-disable-next-line no-throw-literal
      throw 'Erro ao enviar mensagem'
    }

    // After message creation update the created at date
    // localMessage.dataDeEnvio = res.data.dataDeEnvio

    // After message creation update the created message
    this.context.commit('setMessage', { index: messageIndex, message: localMessage })

    return res.data
  }

  @Mutation
  setRecebimento(value: Recebimento) {
    this.recebimento = value
  }

  @Action
  async startChat() {
    // const messageRes = await RemuneracaoMedicaChatApi.createMessage(this.hospitalId, message)
    // if (!messageRes.success) {
    //   EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao enviar mensagem', icon: 'warning', color: '#C62828' })
    //   // eslint-disable-next-line no-throw-literal
    //   throw 'Erro ao enviar mensagem'
    // }

    // this.context.commit('addMessage', messageRes.data)

    this.context.commit('setFinished', false)

    await this.context.dispatch('openConnection')

    return true
  }

  @Action
  async openChatModalBackoffice(data: IRemuneracaoChatMessage) {
    const {
      identificador,
      nomeGrupo,
      userId,
      hospitalId,
      ehUsuarioAtendimento,
      recebimento,
    } = data

    this.context.commit('setOpen', true)
    this.context.commit('setIdentificador', identificador)
    this.context.commit('setUserId', userId)
    this.context.commit('setHospitalId', hospitalId)
    this.context.commit('setNomeGrupo', nomeGrupo)
    this.context.commit('setEhUsuarioAtendimento', ehUsuarioAtendimento)
    this.context.commit('setRecebimento', recebimento)
    this.context.commit('setConnectionData', data)

    EventBus.$emit('setLoadingRequest', { status: '', text: 'Carregando...' })

    try {
      await this.context.dispatch('loadChatData')

      if (this.canOpenConnection) {
        await this.context.dispatch('openConnection')
        // eslint-disable-next-line
        console.log('connection opened')
      }
      // eslint-disable-next-line no-empty
    } catch (err) { }

    EventBus.$emit('clearLoadingRequest')
  }

  @Action
  async openChatModalMedic(data: IRemuneracaoChatMessage) {
    const {
      identificador,
      nomeGrupo,
      userId,
      hospitalId,
      ehUsuarioAtendimento,
      recebimento,
    } = data

    this.context.commit('setOpen', true)
    this.context.commit('setUserId', userId)
    this.context.commit('setIdentificador', identificador)
    this.context.commit('setHospitalId', hospitalId)
    this.context.commit('setNomeGrupo', nomeGrupo)
    this.context.commit('setEhUsuarioAtendimento', ehUsuarioAtendimento)
    this.context.commit('setRecebimento', recebimento)
    this.context.commit('setConnectionData', data)

    EventBus.$emit('setLoadingRequest', { status: '', text: 'Carregando...' })

    try {
      if (this.canOpenConnection) {
        await this.context.dispatch('openConnection')
        await this.context.dispatch('loadChatData')
        // eslint-disable-next-line
        console.log('connection opened')
      }
      // eslint-disable-next-line no-empty
    } catch (err) {
      await this.context.dispatch('loadChatData')
    }

    EventBus.$emit('clearLoadingRequest')
  }

  @Action
  async loadChatData() {
    try {
      const chatId = this.identificador
      const response = await this.remuneracaoMedica.getChatsInfo(chatId)

      if (response.success) {
        this.context.dispatch('setChatData', response.data)
      }

      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async setChatData(data: any) {
    // this.context.commit('setRecipientLastSeenDate', data.dataDaUltimaVisualizacaoDoBackoffice)
    this.context.commit('setMessages', data)
    // this.context.commit('setSolicitation', data.solicitacao)
    // this.context.commit('setFinished', data.chatFinalizado !== undefined ? data.chatFinalizado : null)
  }

  @Action
  async closeChatModal() {
    await this.context.dispatch('closeConnection')
    this.context.commit('setOpen', false)
    this.context.dispatch('reset')
  }

  @Action
  async encerrarAtendimento() {
    try {
      const params: any = {
        nomeGrupo: this.identificador,
        identificador: this.identificador,
        ehUsuarioAtendimento: this.ehUsuarioAtendimento,
      }

      const response = await this.remuneracaoMedica.encerrarAtendimento(params)

      if (response.success) {
        this.context.commit('setFinished', true)
        this.closeConnection()
      }

      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async openConnection() {
    await chatRemuneracaoConnectionService.openConnection(this.connectionData)
  }

  @Action
  async closeConnection() {
    await chatRemuneracaoConnectionService.closeConnection(this.connectionData)
  }

  @Mutation
  setOpen(value: boolean) {
    this.open = value
  }

  @Mutation
  setConnectionData(data: IRemuneracaoChatMessage) {
    this.connectionData = data
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  setUserId(value: string) {
    this.userId = value
  }

  @Mutation
  setIdentificador(value: string) {
    this.identificador = value
  }

  @Mutation
  setNomeGrupo(value: string) {
    this.nomeGrupo = value
  }

  @Mutation
  setEhUsuarioAtendimento(value: boolean) {
    this.ehUsuarioAtendimento = value
  }

  @Mutation
  setRecipientLastSeenDate(value: string) {
    this.recipientLastSeenDate = value
  }

  @Mutation
  addMessage(value: IRemuneracaoChatMessage) {
    this.messages.push(value)
  }

  @Mutation
  setMessage(data: { index: number, message: IRemuneracaoChatMessage }) {
    this.messages.splice(data.index, 1, data.message)
  }

  @Mutation
  setMessages(value: IRemuneracaoChatMessage[]) {
    this.messages = value
  }

  @Mutation
  setFinished(value: boolean) {
    this.finished = value
  }

  @Mutation
  setLoading(value: boolean) {
    this.loading = value
  }

  @Action
  reset() {
    // TODO
  }

  // Getters

  get isOpen() {
    return this.open
  }

  get isNew() {
    return this.finished || this.finished == null
  }

  get canOpenConnection() {
    return this.finished || this.finished === false
  }
}
